// extracted by css-extract-rspack-plugin
export default {"label":"YNTDE54gYuABbmMH","required":"Sbrv02P0R60ZYQna"};